import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assignment-expiration-modal',
  templateUrl: './assignment-expiration-modal.component.html',
  styleUrls: ['./assignment-expiration-modal.component.scss']
})
export class AssignmentExpirationModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }


}
